var _path, _path2, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIllus1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6658 11.6H10.9455C10.7547 11.6 10.6 11.7547 10.6 11.9455V14.8637C10.6 15.0544 10.7547 15.2091 10.9455 15.2091H48.6658C48.8566 15.2091 49.0112 15.0544 49.0112 14.8637V11.9455C49.0112 11.7547 48.8566 11.6 48.6658 11.6ZM10.9455 10C9.87101 10 9 10.871 9 11.9455V14.8637C9 15.9381 9.87101 16.8091 10.9455 16.8091H48.6658C49.7402 16.8091 50.6112 15.9381 50.6112 14.8637V11.9455C50.6112 10.871 49.7402 10 48.6658 10H10.9455Z",
    fill: "url(#paint0_linear_2_5239)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.6658 22.9486H10.9455C10.7547 22.9486 10.6 23.1033 10.6 23.2941V50.4225C10.6 50.6132 10.7547 50.7679 10.9455 50.7679H48.6658C48.8566 50.7679 49.0112 50.6132 49.0112 50.4225V23.2941C49.0112 23.1033 48.8566 22.9486 48.6658 22.9486ZM10.9455 21.3486C9.87101 21.3486 9 22.2196 9 23.2941V50.4225C9 51.4969 9.87101 52.3679 10.9455 52.3679H48.6658C49.7402 52.3679 50.6112 51.4969 50.6112 50.4225V23.2941C50.6112 22.2196 49.7402 21.3486 48.6658 21.3486H10.9455Z",
    fill: "#FF6C00"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17.3223,
    y: 26.6445,
    width: 18.1576,
    height: 1.51314,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5059,
    y: 26.6445,
    width: 3.78284,
    height: 1.51314,
    fill: "#FF6C00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3223,
    y: 32.6973,
    width: 18.1576,
    height: 1.51314,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5059,
    y: 32.6973,
    width: 3.78284,
    height: 1.51314,
    fill: "#FF6C00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3223,
    y: 38.7495,
    width: 18.1576,
    height: 1.51314,
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5059,
    y: 38.7495,
    width: 3.78284,
    height: 1.51314,
    fill: "white"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 17.3223,
    y: 44.8022,
    width: 18.1576,
    height: 1.51314,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 38.5059,
    y: 44.8022,
    width: 3.78284,
    height: 1.51314,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_5239",
    x1: 50.6112,
    y1: 16.8091,
    x2: 19.5446,
    y2: 16.8091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF6C00",
    stopOpacity: 0.26
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllus1);
export default __webpack_public_path__ + "static/media/illus1.c20049afe4fc0553176a7c01955a43fa.svg";
export { ForwardRef as ReactComponent };